import { IReduxState } from 'types/redux';

export const widgetsSelector = (state: IReduxState) => state.widgets;
